import cancelShippingApi from 'service/cancel-shipping-api';

export const cancelShippingUseCase = async (companyId, loggiKey) => {
  return cancelShippingApi.cancel(companyId, loggiKey);
};

export default { cancelShippingUseCase };
